module.exports = __webpack_public_path__ + "assets/img/icon-z2-2.812c72c9.png";